module.exports = __webpack_public_path__ + "img/41.407ae7e3.png";